import React 			from 'react';

import BLComponent		from '../../core/_BLComponent.jsx';
import WebinarBanner 	from './_WebinarBanner.jsx';

import {BDPHorizontalNoTag, BDPStackedNoTag} from './_BDPLogo.jsx';

export default class BDPHeader extends BLComponent {
	constructor (props, context) {
		super(props, context);
	}

	render() {
		const {classes = ""} = this.props;

 		return (
			<section className={`bdp-series-main__header bdp-series-upcoming__header ${classes}`} data-ts-name="bdp-series-main__header">
				<div className="edge-to-edge-container__internal bdp-series-main__header-internal l-pad-top">
					{this.props.series &&
						<div className="text--left">
							<a href={blapp.url2.getCrowdProjectMainUrl()} className="text-color--white"><i className="fas fa-long-arrow-left l-margin-right"/>Back</a>
						</div>
					}
					{this.props.children ? this.props.children : <WebinarBanner/>}
					<div className="bdp-introduce__logo-lockup bdp-series-main__header-lockup">
						<BDPHorizontalNoTag classes="bdp-series-main__header-logo bdp-series-main__header-logo--desktop"/>
						<BDPStackedNoTag classes="bdp-series-main__header-logo bdp-series-main__header-logo--mob"/>
						<h1 className="bdp-introduce__logo-lockup-tag bdp-series-main__header-title bdp-series-main__header-title--bordered">Designed by LEGO<sup>&reg;</sup> fans for experienced builders.</h1>
					</div>
				</div>
			</section>
		);
	}
}